import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'

import { AppActions } from '../../actions'

export const useAppDispatch = () => {
  return useDispatch<Dispatch<AppActions>>()
}
